var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.599 12L16.599 20M16.599 12L24.599 20M27.2656 6.66666H12.599L3.26562 16L12.599 25.3333H27.2656C27.9729 25.3333 28.6511 25.0524 29.1512 24.5523C29.6513 24.0522 29.9323 23.3739 29.9323 22.6667V9.33332C29.9323 8.62608 29.6513 7.9478 29.1512 7.4477C28.6511 6.94761 27.9729 6.66666 27.2656 6.66666Z",
    stroke: "#1480C1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRow);
export default __webpack_public_path__ + "static/media/deleteRow.30b3ee49a8ec22b5148a00f33759a55c.svg";
export { ForwardRef as ReactComponent };